// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { IStyle } from '@fluentui/react';

/** @private */
export const controlBarContainerStyles: IStyle = {
  paddingTop: '0.25rem',
  paddingBottom: '0.25rem'
};